<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">设备日志</span>
      </div>
      <div class="right">
        <Button type="primary" @click="addLog()">新增日志</Button>
      </div>
    </div>
    <div class="filter-box">
      <div style="display: flex; align-items: center">
        <span class="subtitle">设备序列号:</span>
        <Input
          v-model="page.sn"
          placeholder="请输入设备序列号"
          style="width: 200px; margin: 0 10px"
        />
        <span class="subtitle">站点:</span>
        <Input
          v-model="page.site_name"
          placeholder="请输入站点"
          style="width: 200px; margin: 0 10px"
        >
        </Input>
        <span class="subtitle">合作伙伴:</span>
        <Select
          v-model="page.agent_id"
          class="item"
          filterable
          style="width: 200px; margin-left: 5px"
          placeholder="请选择"
        >
          <Option
            v-for="(item, index) in agentList"
            :key="index"
            :value="item.id"
            >{{ item.agent_name }}</Option
          >
        </Select>

        <span class="subtitle" style="margin-left: 10px">当前状态:</span>
        <Select v-model="page.status" style="width: 200px; margin-left: 10px">
          <Option :value="-1" :key="-1">全部</Option>
          <Option :value="0" :key="0">未开始</Option>
          <Option :value="1" :key="1">收集中</Option>
          <Option :value="2" :key="2">失败</Option>
          <Option :value="3" :key="3">上传中</Option>
          <Option :value="4" :key="4">完成</Option>
        </Select>
      </div>
      <div class="bottom">
        <span class="btn-filter" @click="getData()">筛选</span>
        <span class="btn" @click="reset">清空</span>
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="list">
        <template slot-scope="{ row }" slot="status">
          <span>{{ status[row.status].name }}</span>
        </template>
      </Table>
      <div class="t-right" style="margin-top: 20px">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :current="page.p + 1"
          :total="total"
          :page-size="10"
          show-elevator
          show-sizer
          show-total
        />
      </div>
    </div>

    <Modal
      v-model="modal.visible"
      title="新增设备日志"
      :width="500"
      footer-hide
    >
      <Form ref="loginForm" :model="modal.data" :label-width="100">
        <FormItem prop="sn" label="选择设备:">
          <Select
            v-model="modal.data.machine_id"
            style="width: 300px"
            filterable
            placeholder="输入序列号"
          >
            <Option
              v-for="(item, index) in machine"
              :key="index"
              :value="item.id"
              :label="item.sn"
            >
              <span>{{ item.sn }}</span>
              <span style="margin-left: 10px; color: #ccc">{{
                item.site_name
              }}</span></Option
            >
          </Select>
        </FormItem>
        <FormItem prop="remarks" label="备注:">
          <Input
            v-model="modal.data.note"
            style="width: 300px"
            placeholder="备注设备有什么问题"
            class="input"
          >
          </Input>
        </FormItem>
        <FormItem>
          <Button type="primary" v-preventReClick @click="submit">确定</Button>
          <Button @click="modal.visible = false" style="margin-left: 10px"
            >取消</Button
          >
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Axios from 'axios'
export default {
  data () {
    return {
      modal: {
        visible: false,
        data: {
          machine_id: '',
          note: ''
        }
      },
      machine: [],
      list: [],
      columns: [
        { title: '编号', key: 'id', width: '80' },
        { title: '设备序列号', key: 'sn', width: '150' },
        { title: '设备站点', key: 'site_name', width: '300' },
        { title: '所属合作伙伴', key: 'agent_name', width: '300' },
        { title: '日志开始时间', key: 'start_time', width: '150' },
        { title: '日志结束时间', key: 'end_time', width: '150' },
        { title: '当前状态', key: 'status', slot: 'status', width: '100' },
        { title: '大小', key: 'size', width: '150' },
        { title: '备注', key: 'note', width: '150' },
        {
          title: '操作',
          key: 'operate',
          width: '200',
          fixed: 'right',
          render: (h, data) => {
            let temp = []
            let status = data.row.status
            if (status !== 1) {
              temp.push(
                h(
                  'Button',
                  {
                    props: {
                      size: 'small',
                      type: 'error'
                    },
                    on: {
                      click: () => {
                        this.delete(data.row)
                      }
                    }
                  },
                  '删除'
                )
              )
            }
            if (status == 2 || status == 3) {
              temp.push(
                h(
                  'Button',
                  {
                    props: { size: 'small', type: 'warning' },
                    style: { marginLeft: '5px' },
                    on: {
                      click: () => {
                        this.changeStatus(data.row.id, data.row.sn, 3)
                      }
                    }
                  },
                  '重新上传'
                )
              )
            }
            if (status == 0 || status == 2) {
              temp.push(
                h(
                  'Button',
                  {
                    props: { size: 'small', type: 'success' },
                    style: { marginLeft: '5px' },
                    on: {
                      click: () => {
                        this.changeStatus(data.row.id, data.row.sn, 1)
                      }
                    }
                  },
                  '开启'
                )
              )
            }
            if (status == 1) {
              temp.push(
                h(
                  'Button',
                  {
                    props: { size: 'small', type: 'warning' },
                    style: { marginLeft: '5px' },
                    on: {
                      click: () => {
                        this.changeStatus(data.row.id, data.row.sn, 3)
                      }
                    }
                  },
                  '终止'
                )
              )
            }
            if (status == 4) {
              temp.push(
                h(
                  'Button',
                  {
                    props: { size: 'small', type: 'success' },
                    style: { marginLeft: '5px' },
                    on: {
                      click: () => {
                        this.downloadLogFile(data.row.url)
                      }
                    }
                  },
                  '下载'
                )
              )
            }
            return temp
          }
        }
      ],
      status: {
        0: { name: '未开始' },
        1: { name: '收集中' },
        2: { name: '失败' },
        3: { name: '上传中' },
        4: { name: '完成' }
      },
      page: {
        p: 0,
        l: 10,
        sn: '',
        site_name: '',
        agent_id: 0,
        status: -1
      },
      total: 0,
      agentList: []
    }
  },
  mounted () {
    this.getData()
    this.getMachineList()
    this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then((res) => {
      this.agentList = res.data
    })
  },
  methods: {
    ...mapActions([
      'GetMachineListData',
      'SaveMachineLog',
      'GetMachineLogList',
      'socketSend',
      'getAgentList'
    ]),
    getMachineList () {
      this.GetMachineListData({
        l: 100000,
        p: 0
      }).then((res) => {
        this.machine = res.data
      })
    },
    getData () {
      console.log('参数', this.page)
      this.GetMachineLogList(this.page).then((res) => {
        this.total = res.total
        this.list = res.data
        this.list.map((item) => {
          item.start_time = item.start_time
            ? this.$moment(item.start_time, 'YYYY-MM-DD HH:mm')
            : ''
          item.end_time = item.end_time
            ? this.$moment(item.end_time, 'YYYY-MM-DD HH:mm')
            : ''
        })
      })
    },
    addLog () {
      this.modal = {
        visible: true,
        data: {
          machine_id: '',
          note: ''
        }
      }
    },
    submit () {
      let data = this.modal.data
      if (!data.machine_id) {
        this.$Message.error('请选择设备!')
        return
      }
      this.SaveMachineLog(data).then((res) => {
        this.modal.visible = false
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (res.status) {
          this.reset()
        }
      })
    },
    delete (row) {
      let data = {
        id: row.id,
        is_del: 1
      }
      console.log('row', row)
      if (row.status != 0 && row.status != 4) {
        // 停止收集日志并删除设备端上的日志
        this.socketSend({
          // 10012 停止收集
          action: 10012,
          value: {
            sn: row.sn,
            id: row.id,
            cancel: true
          }
        })
      }
      this.SaveMachineLog(data).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (res.status) {
          this.getData()
        }
      })
      if (row.status > 2) {
        // 删除文件服务器上的日志文件
        var url = `https://change3.aidprint.com/FileDelete/delete?path=//${row.sn}//${row.id}&isLog=true`
        // var url = `http://change3.aidprint.com/FileDelete/delete?path=//3089M400028//31&isLog=true`;
        Axios.post(url)
      }
    },
    changeStatus (id, sn, status) {
      let data = {
        id,
        status
      }
      let now = new Date()
      if (status == 1) {
        data.start_time = this.$moment(now, 'YYYY-MM-DD HH:mm')
      } else {
        data.end_time = this.$moment(now, 'YYYY-MM-DD HH:mm')
      }
      this.SaveMachineLog(data).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (res.status) {
          this.getData()
          let index = 0
          let that = this
          // 立即发送一条socket消息通知设备
          this.socketSend({
            // 10011开始收集日志  10012 停止收集
            action: status == 1 ? 10011 : 10012,
            value: {
              sn,
              id
            }
          })
          // 每隔8秒发送4次socket预防设备终端网络不畅
          setInterval(function () {
            if (index < 5) {
              that.socketSend({
                // 10011开始收集日志  10012 停止收集
                action: status == 1 ? 10011 : 10012,
                value: {
                  sn,
                  id
                }
              })
            }
            index++
          }, 8000)
        }
      })
    },
    downloadLogFile (url) {
      window.location.href = url
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    staffChange () {
      this.getData()
    },
    // 重置获取数据
    reset () {
      this.page = {
        p: 0,
        l: 10,
        sn: '',
        site_name: '',
        agent_id: 0,
        status: -1
      }
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
